export class ContinuationTokenResponseModel<T> {
  continuationToken: string;
  model: T;
}
